import { LoadableAfterPaint } from '@confluence/loadable';

export const BackupManagerButton = LoadableAfterPaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-ButtonsBackupManagerButton" */ '../src/Buttons/BackupManagerButton.tsx'
			)
		).BackupManagerButton,
});
